import { useQuery, useMutation, invalidateKeys } from '../lib/query';
import {
  listPlaceActivityQueue,
  listAllPlaceActivities,
  listActivityCatalog,
  createPlaceActivity,
  savePlaceActivities,
  updatePlaceActivity,
  moderatePlaceActivities,
} from '../services/placeActivities';

const QUEUE_KEY = 'place-activities-queue';
const ALL_KEY = 'place-activities-all';
const CATALOG_KEY = 'activities-catalog';

// Any change to a mapping can move it between the queue and the "all" list, so
// refresh both.
const refreshLists = () => {
  invalidateKeys([QUEUE_KEY]);
  invalidateKeys([ALL_KEY]);
};

export const usePlaceActivityQueue = (params, opts = {}) =>
  useQuery({
    queryKey: [QUEUE_KEY, params],
    queryFn: () => listPlaceActivityQueue(params),
    enabled: opts.enabled,
  });

export const useAllPlaceActivities = (params, opts = {}) =>
  useQuery({
    queryKey: [ALL_KEY, params],
    queryFn: () => listAllPlaceActivities(params),
    enabled: opts.enabled,
  });

// Master catalog for the picker — enable lazily (only when a modal is open).
export const useActivityCatalog = (opts = {}) =>
  useQuery({
    queryKey: [CATALOG_KEY],
    queryFn: () => listActivityCatalog(),
    enabled: opts.enabled,
  });

export const useCreatePlaceActivity = (opts = {}) =>
  useMutation({
    mutationFn: (body) => createPlaceActivity(body),
    onSuccess: (data, vars) => { refreshLists(); opts.onSuccess?.(data, vars); },
    onError: opts.onError,
  });

// Batch approve: upsert every row (with moderated:true) in one request.
export const useSavePlaceActivities = (opts = {}) =>
  useMutation({
    mutationFn: (items) => savePlaceActivities(items),
    onSuccess: (data, vars) => { refreshLists(); opts.onSuccess?.(data, vars); },
    onError: opts.onError,
  });

export const useUpdatePlaceActivity = (opts = {}) =>
  useMutation({
    mutationFn: ({ id, body }) => updatePlaceActivity(id, body),
    onSuccess: (data, vars) => { refreshLists(); opts.onSuccess?.(data, vars); },
    onError: opts.onError,
  });

export const useModeratePlaceActivities = (opts = {}) =>
  useMutation({
    mutationFn: ({ ids, moderated }) => moderatePlaceActivities(ids, moderated),
    onSuccess: (data, vars) => { refreshLists(); opts.onSuccess?.(data, vars); },
    onError: opts.onError,
  });
